import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import styles from "./ApplicationCreatedModal.module.css";

type Props = {
  title: string;
  peopleCount: number;
  onClose: () => void;
};

const ApplicationCreatedModal = ({ title, peopleCount, onClose }: Props) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const handleGo = () => {
    onClose();
    navigate("/home?welcome=true");
  };
  const subtitle =
    peopleCount <= 1
      ? _t("applyingOnYourOwn", "You're applying on your own")
      : _t(
          "applyingAsGroup",
          `You're applying with ${peopleCount} people`,
          undefined,
          { peopleCount: peopleCount }
        );

  return (
    <div className={styles.overlay} role="dialog" aria-modal="true">
      <div className={styles.card}>
        <div className={styles.check}>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M6 12.5 10 16.5 18 7.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h2>{_t("applicationCreated", "Application created")}</h2>
        <p className={styles.appTitle}>{title}</p>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.info}>
          <span className={styles.clock} aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle
                cx="12"
                cy="12"
                r="8.5"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
              />
              <path
                d="M12 8.5V12l3 2"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          </span>
          {_t(
            "processingProfiles",
            "We're processing the profiles and we'll email you when everything is live"
          )}
        </div>
        <button className={styles.cta} type="button" onClick={handleGo}>
          {_t("goToMyDashboard", "Go to my dashboard")}
        </button>
      </div>
    </div>
  );
};

export default ApplicationCreatedModal;
